import type { ReactNode } from "react";
import { NavLink, Outlet } from "react-router-dom";

import { Button } from "../shared/ui/button.js";
import { navigationItems } from "./navigation.js";

interface AppShellProps {
  readonly email?: string;
  readonly isAdmin: boolean;
  readonly onSignOut: () => void;
  readonly children?: ReactNode;
}

export function AppShell({ children, email, isAdmin, onSignOut }: AppShellProps) {
  const visibleItems = navigationItems.filter((item) => item.adminOnly !== true || isAdmin);
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <aside className="app-sidebar">
        <div className="brand-lockup">
          <span className="brand-lockup__mark" aria-hidden="true">
            AT
          </span>
          <div>
            <strong>TradingApp</strong>
            <span>Stock bot operations</span>
          </div>
        </div>
        <nav aria-label="Primary navigation" className="primary-navigation">
          {visibleItems.map((item) => (
            <NavLink key={item.to} to={item.to}>
              <span aria-hidden="true" className="navigation-dot" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="session-summary">
          <span>Signed in</span>
          <strong>{email ?? "TradingApp user"}</strong>
          <Button tone="quiet" onClick={onSignOut}>
            Sign out
          </Button>
        </div>
      </aside>
      <div className="app-workspace">
        <header className="mobile-header">
          <div className="brand-lockup">
            <span className="brand-lockup__mark" aria-hidden="true">
              AT
            </span>
            <strong>TradingApp</strong>
          </div>
          <Button tone="quiet" onClick={onSignOut}>
            Sign out
          </Button>
        </header>
        <main id="main-content" tabIndex={-1}>
          {children ?? <Outlet />}
        </main>
      </div>
      <nav aria-label="Mobile navigation" className="mobile-navigation">
        {visibleItems.map((item) => (
          <NavLink key={item.to} to={item.to}>
            {item.shortLabel}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
